/**
 * Zugriff auf Fußnoten, Endnoten und weitere Verweise.
 *
 * Fuß- und Endnoten gibt es ab WordApi 1.5. Abbildungsverzeichnis und
 * Literaturverwaltung sind nur in der Desktop-Version zugänglich – für sie
 * weichen die Lektionen auf die Formatvorlagen im Dokument aus.
 */

import { supportsWordApi, wordApi } from "./capabilities";
import { isWordAvailable, WordUnavailableError } from "./document";

export interface NoteInfo {
  /** Text der Notiz. */
  text: string;
}

export interface NotesSnapshot {
  footnotes: NoteInfo[];
  endnotes: NoteInfo[];
}

/** Fuß- und Endnoten des Dokuments – `null`, wenn WordApi 1.5 fehlt. */
export async function readNotes(): Promise<NotesSnapshot | null> {
  if (!isWordAvailable()) throw new WordUnavailableError();
  if (!supportsWordApi(wordApi.notes)) return null;

  try {
    return await Word.run(async (context) => {
      const footnotes = context.document.body.footnotes;
      const endnotes = context.document.body.endnotes;
      footnotes.load("items/body/text");
      endnotes.load("items/body/text");
      await context.sync();

      const toInfo = (items: Word.NoteItem[]): NoteInfo[] =>
        items.map((item) => ({
          text: typeof item.body?.text === "string" ? item.body.text.trim() : "",
        }));

      return { footnotes: toInfo(footnotes.items), endnotes: toInfo(endnotes.items) };
    });
  } catch {
    return null;
  }
}
